import React from 'react';
import './ProductLogosScroller.css';

const ProductLogosScroller = ({ logos }) => {
    if (!logos || logos.length === 0) return null;

    // Remove duplicate logo URLs
    const uniqueLogos = Array.from(new Set(logos));

    // Split logos into 3 nearly equal rows
    const rowCount = 3;
    const rows = Array.from({ length: rowCount }, (_, i) =>
        uniqueLogos.filter((_, idx) => idx % rowCount === i)
    );

    return (
        <div className="product-logos-scroller multi-row">
            {rows.map((row, rowIdx) => (
                <div
                    className={`logos-track${rowIdx === 1 ? ' middle' : ''}`}
                    key={rowIdx}
                >
                    {row.map((logo, idx) => (
                        <div className="logo-item" key={idx}>
                            <img src={logo} alt="Product Logo" />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default ProductLogosScroller;